import { useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useWorker } from "../context/WorkerContext";
import {
  ChevronLeft,
  Edit2,
  Cake,
  Contact,
  GraduationCap,
  Home,
  Wrench,
  MapPin,
  CheckCircle,
  Building2,
  Camera,
  X,
  Clock
} from "lucide-react";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import WorkerDetailModal from "./workerDetailModal";
import DobAddressModal from "./dob&addressModal";
import AgreementModal from "./agreementModal";
import SelfieImage from "./SelfiImage";
import ConfirmModal from "./ConfirmModal";

const MyDetailsPage = () => {
  const { user, setUser, token } = useWorker();
  const navigate = useNavigate();

  const [showWorkerDetailModal, setShowWorkerDetailModal] = useState(false);
  const [showDobAddressModal, setShowDobAddressModal] = useState(false);
  const [showAgreementModal, setShowAgreementModal] = useState(false);
  const [showSelfieModal, setShowSelfieModal] = useState(false);
  const [showViewSelfieModal, setShowViewSelfieModal] = useState(false);
  const [showRemarks, setShowRemarks] = useState(false);
const remarksRef = useRef(null);
const [showAccountRemarks, setShowAccountRemarks] = useState(false);
const accountRemarksRef = useRef(null);

useEffect(() => {
  const handleClickOutside = (e) => {
    if (
      accountRemarksRef.current &&
      !accountRemarksRef.current.contains(e.target)
    ) {
      setShowAccountRemarks(false);
    }
  };
  document.addEventListener("mousedown", handleClickOutside);
  return () => document.removeEventListener("mousedown", handleClickOutside);
}, []);

useEffect(() => {
  const handleClickOutside = (e) => {
    if (remarksRef.current && !remarksRef.current.contains(e.target)) {
      setShowRemarks(false);
    }
  };
  document.addEventListener("mousedown", handleClickOutside);
  return () => document.removeEventListener("mousedown", handleClickOutside);
}, []);
  const [showAadhaarConfirm, setShowAadhaarConfirm] = useState(false);

  const handleProfileImageClick = () => {
    if (user?.profilePhotoUrl) {
      setShowViewSelfieModal(true);
    } else {
      setShowSelfieModal(true);
    }
  };

  const handleReuploadSelfie = () => {
    setShowViewSelfieModal(false);
    setShowSelfieModal(true);
  };

  const handleSelfieComplete = () => {
    setShowSelfieModal(false);
    toast.success("Profile photo updated successfully!");
  };

  const handleDobAddressSuccess = () => {
  setShowDobAddressModal(false);
  setTimeout(() => setShowAgreementModal(true), 300);
};

  const hasAadhaarDetails = !!(user?.dob && user?.address);

const handleAadhaarEditClick = () => {
  if (hasAadhaarDetails) {
    setShowAadhaarConfirm(true);
  } else {
    setShowDobAddressModal(true);
  }
};

const handleAadhaarConfirm = () => {
  setShowAadhaarConfirm(false);
  setShowDobAddressModal(true);
};

  const handleAgreementSuccess = (isSuccess) => {
  setShowAgreementModal(false);
  if (isSuccess) {
    setUser((prev) => ({ ...prev, isAgreementSigned: true }));
    toast.success("Agreement accepted successfully!");
  }
};

  const personalRows = [
    {
      icon: <Contact className="w-5 h-5 text-gray-500" />,
      label: `${user?.relativeType || "Relative"} Contact No`,
      value: user?.relativeNumber
        ? `${user.relativeNumber}${user.relativeName ? ` (${user.relativeName})` : ""}`
        : "Not provided",
    },
    {
      icon: <GraduationCap className="w-5 h-5 text-gray-500" />,
      label: "Highest Education",
      value: user?.highestQualification || "Not provided",
    },
    {
      icon: <Home className="w-5 h-5 text-gray-500" />,
      label: "Current Address",
      value: user?.temporaryAddress || "Not provided",
    },
    {
      icon: <Wrench className="w-5 h-5 text-gray-500" />,
      label: "Skills",
      value:
        user?.skills && user.skills.length > 0
          ? user.skills.join(", ")
          : "Not provided",
    },
    {
      icon: <MapPin className="w-5 h-5 text-gray-500" />,
      label: "Preferred Location",
      value: user?.preferredLocation || "Not provided",
    },
    ...(user?.lastcompanyName
      ? [
          {
            icon: <Building2 className="w-5 h-5 text-gray-500" />,
            label: "Last Company",
            value: user.lastcompanyName,
          },
        ]
      : []),
  ];

  const aadhaarRows = [
    {
      icon: <Cake className="w-5 h-5 text-gray-500" />,
      label: "Date of Birth",
      value: user?.dob || "Not provided",
    },
    {
      icon: <Home className="w-5 h-5 text-gray-500" />,
      label: "Permanent Address",
      value: user?.address || "Not provided",
    },
  ];

  return (
    // Added pt-16 to account for fixed header (matches JobDetailsView's -mt-8 offset)
    <div className="min-h-screen bg-white font-montserrat max-w-md mx-auto pt-20">
       <ToastContainer
  position="top-center"
  autoClose={3000}
  style={{ zIndex: 99999 }}  
  toastStyle={{ zIndex: 99999 }} 
/>

      {/* Header - Changed pt-16 to pt-4 since parent now has pt-16 */}
      <div className="flex items-center justify-between px-4 pt-4">
        <button
          onClick={() => navigate(-1)}
          className="p-1 text-gray-700 hover:text-gray-900 transition-colors"
        >
          <ChevronLeft className="w-6 h-6" />
        </button>
        <h1 className="text-xl font-bold text-center font-montserrat">
          My Details
        </h1>
        <div className="w-7" />
      </div>

      {/* Profile Section */}
<div className="flex flex-col items-center pt-6 px-6 pb-4">
  {/* Clickable profile image — same logic as JobDetailsView */}
  <div
    className="relative w-28 h-28 cursor-pointer group"
    onClick={handleProfileImageClick}
    title="Click to view or change photo"
  >
    <div className="w-28 h-28 rounded-full border-[3px] border-green-500 overflow-hidden bg-gray-200 flex items-center justify-center">
      {user?.profilePhotoUrl ? (
        <img
          src={user.profilePhotoUrl}
          alt="Profile"
          className="w-full h-full object-cover"
        />
      ) : (
        <svg viewBox="0 0 100 100" className="w-full h-full" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="50" cy="38" r="20" fill="#bdbdbd" />
          <ellipse cx="50" cy="82" rx="30" ry="20" fill="#bdbdbd" />
        </svg>
      )}
    </div>
    {/* Camera overlay on hover */}
    <div className="absolute inset-0 rounded-full bg-black bg-opacity-0 group-hover:bg-opacity-30 flex items-center justify-center transition-all duration-200">
      <Camera className="w-6 h-6 text-white opacity-0 group-hover:opacity-100 transition-opacity duration-200" />
    </div>
  </div>

  <h2 className="text-2xl font-bold text-gray-900 font-montserrat mt-3 text-center">
    {user?.name || "User Name"}
  </h2>
  <p className="text-sm text-gray-600 font-montserrat mt-0.5">
    {user?.workerCode || "Worker Code"}
  </p>
  <p className="text-gray-500 text-base font-montserrat mt-0.5 mb-4">
    {user?.gender || "—"}
  </p>

  {/* Badges wrapper */}
  <div className="flex flex-nowrap items-center justify-center gap-1 w-full">
  {/* Aadhaar */}
  <div
    className={`flex items-center gap-1 px-2 py-1 rounded-full text-[10px] sm:text-xs font-semibold whitespace-nowrap ${
      user?.aadharVerified
        ? "bg-green-100 text-[#09A22F]"
        : "bg-red-100 text-red-600"
    } font-montserrat`}
  >
    {user?.aadharVerified ? (
      <>
        <CheckCircle className="w-3 h-3 shrink-0" />
        <span>Aadhaar</span>
      </>
    ) : (
      <span>✗ Aadhaar</span>
    )}
  </div>

  {/* RefCheck */}
<div ref={remarksRef} className="relative inline-block">
  <div
    onClick={() => setShowRemarks((prev) => !prev)}
    className={`flex items-center gap-1 px-2 py-1 rounded-full text-[10px] sm:text-xs font-semibold whitespace-nowrap cursor-pointer ${
      user?.refcheckverified === true
        ? "bg-green-100 text-[#09A22F]"
        : user?.refcheckverified === false
        ? "bg-red-100 text-red-600"
        : "bg-yellow-100 text-yellow-700"
    } font-montserrat`}
  >
    {user?.refcheckverified === true ? (
      <>
        <CheckCircle className="w-3 h-3 shrink-0" />
        <span>RefCheck</span>
      </>
    ) : user?.refcheckverified === false ? (
      <span>✗ RefCheck</span>
    ) : (
      <>
        <Clock className="w-3 h-3 shrink-0" />
        <span>RefCheck</span>
      </>
    )}
  </div>

  {showRemarks && (
    <div className="absolute left-0 top-full mt-2 z-50 w-56 rounded-lg border border-gray-200 bg-white p-3 shadow-lg">
      <p className="mb-1 text-[10px] sm:text-xs font-semibold text-gray-500 font-montserrat">
        RefCheck Remarks
      </p>
      <p className="text-xs text-gray-800 font-montserrat break-words">
        {user?.refcheckremarks || "No remarks available."}
      </p>
    </div>
  )}
</div>

  {/* Account */}
<div ref={accountRemarksRef} className="relative inline-block">
  <div
    onClick={() => setShowAccountRemarks((prev) => !prev)}
    className={`flex items-center gap-1 px-2 py-1 rounded-full text-[10px] sm:text-xs font-semibold whitespace-nowrap cursor-pointer ${
      user?.accountverified === "success"
        ? "bg-green-100 text-[#09A22F]"
        : user?.accountverified === "failed"
        ? "bg-red-100 text-red-600"
        : "bg-yellow-100 text-yellow-700"
    } font-montserrat`}
  >
    {user?.accountverified === "success" ? (
      <>
        <CheckCircle className="w-3 h-3 shrink-0" />
        <span>Account</span>
      </>
    ) : user?.accountverified === "failed" ? (
      <span>✗ Account</span>
    ) : (
      <>
        <Clock className="w-3 h-3 shrink-0" />
        <span>Account</span>
      </>
    )}
  </div>

  {showAccountRemarks && (
    <div className="absolute left-0 top-full mt-2 z-50 w-56 rounded-lg border border-gray-200 bg-white p-3 shadow-lg">
      <p className="mb-1 text-[10px] sm:text-xs font-semibold text-gray-500 font-montserrat">
        Account Remarks
      </p>
      <p className="text-xs text-gray-800 font-montserrat break-words">
        {user?.accountverifiedremarks || "No remarks available."}
      </p>
    </div>
  )}
</div>
</div>
</div>

      {/* ── Section 1: Personal Details ─────────────────────────────────────── */}
      <div className="px-6 ml-4 mt-2">
        <div className="flex items-center justify-between mb-4">
          <span className="text-base font-bold text-gray-900 font-montserrat">
            Personal Details
          </span>
          <button
            onClick={() => setShowWorkerDetailModal(true)}
            className="flex items-center gap-1 text-green-600 hover:text-green-700 font-medium text-sm transition-colors font-montserrat"
          >
            <Edit2 className="w-4 h-4" />
            <span>Edit</span>
          </button>
        </div>

        <div className="space-y-5">
          {personalRows.map((row, idx) => (
            <div key={idx} className="flex items-start gap-4">
              <div className="mt-1 flex-shrink-0">{row.icon}</div>
              <div className="flex flex-col">
                <span className="text-xs text-gray-400 mb-0.5 font-montserrat">
                  {row.label}
                </span>
                <span className="text-sm font-semibold text-gray-900 leading-snug font-montserrat">
                  {row.value}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Divider */}
      <div className="mx-6 my-6 border-t border-gray-100" />

      {/* ── Section 2: Aadhaar & Address ────────────────────────────────────── */}
      <div className="px-6 ml-4">
        <div className="flex items-center justify-between mb-4">
          <span className="text-base font-bold text-gray-900 font-montserrat">
            Aadhaar & Address
          </span>
          <button
            onClick={handleAadhaarEditClick}
            className="flex items-center gap-1 text-green-600 hover:text-green-700 font-medium text-sm transition-colors font-montserrat"
          >
            <Edit2 className="w-4 h-4" />
            <span>Edit</span>
          </button>
        </div>

        <div className="space-y-5">
          {aadhaarRows.map((row, idx) => (
            <div key={idx} className="flex items-start gap-4">
              <div className="mt-1 flex-shrink-0">{row.icon}</div>
              <div className="flex flex-col">
                <span className="text-xs text-gray-400 mb-0.5 font-montserrat">
                  {row.label}
                </span>
                <span className="text-sm font-semibold text-gray-900 leading-snug font-montserrat">
                  {row.value}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="h-12" />

      {/* ── Modals ──────────────────────────────────────────────────────────── */}
      {showWorkerDetailModal && (
        <WorkerDetailModal
          isOpen={showWorkerDetailModal}
          onClose={(isSuccess) => {
            setShowWorkerDetailModal(false);
            if (isSuccess) toast.success("Personal details updated successfully!");
          }}
          initialData={user}
          editType="personal details"
        />
      )}

      {showDobAddressModal && (
        <DobAddressModal
          onClose={() => setShowDobAddressModal(false)}
          onSuccess={handleDobAddressSuccess}
          isEditing={!!(user?.dob && user?.address)}
        />
      )}

      {showAgreementModal && (
        <AgreementModal
          onClose={handleAgreementSuccess}
          onSuccess={handleAgreementSuccess}
        />
      )}

      {/* View Selfie Modal — mirrors JobDetailsView exactly */}
      {showViewSelfieModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
          <div className="bg-white rounded-2xl w-full max-w-md relative overflow-hidden shadow-2xl">
            <div className="flex items-center justify-between p-6 border-b border-gray-100">
              <h3 className="text-xl font-semibold text-gray-900 flex items-center gap-2">
                <Camera className="h-5 w-5 text-indigo-600" />
                Your Profile Photo
              </h3>
              <button
                onClick={() => setShowViewSelfieModal(false)}
                className="p-2 hover:bg-gray-100 rounded-full transition-colors duration-200"
              >
                <X className="h-5 w-5 text-gray-500 hover:text-gray-700" />
              </button>
            </div>

            <div className="relative p-6">
              <div className="relative group">
                <img
                  src={user?.profilePhotoUrl}
                  alt="Current Selfie"
                  className="w-full h-auto rounded-xl shadow-lg border border-gray-200 max-h-[60vh] object-contain"
                />
                <button
                  onClick={handleReuploadSelfie}
                  className="absolute bottom-4 right-4 w-12 h-12 bg-indigo-600 hover:bg-indigo-700 text-white rounded-full shadow-lg flex items-center justify-center transition-all duration-300 hover:scale-110 hover:shadow-xl"
                  title="Change Photo"
                >
                  <Camera className="h-5 w-5" />
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {showAadhaarConfirm && (
  <ConfirmModal
    title="Replace Aadhaar?"
    message="Are you sure you want to delete your current Aadhaar details and add a new Aadhaar?"
    confirmText="Yes, Continue"
    cancelText="Cancel"
    onConfirm={handleAadhaarConfirm}
    onCancel={() => setShowAadhaarConfirm(false)}
  />
)}

      {/* Upload Selfie Modal */}
      {showSelfieModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
          <div className="bg-white rounded-xl w-full max-w-md relative">
            <SelfieImage
              onSuccess={handleSelfieComplete}
              onClose={() => setShowSelfieModal(false)}
              mandatory={false}
              token={token}
               setUser={setUser}
               user={user}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default MyDetailsPage;